<dl id="notifications" class="shadow-sm" [ngClass]="{'show': notificationService.showNotifications == true}">
  <dt tabindex="-1">
    Notificaciones

    <mat-icon aria-hidden="true" matBadge="{{ notificationService.messageCount }}"
      *ngIf="notificationService.messageCount > 0" matBadgeColor="warn">
      notification_important
    </mat-icon>

    <button (click)="toggleNotifications()" class="close" mat-button>
      <mat-icon>close</mat-icon>
      <span class="sr-only">Cerrar notificaciones</span>
    </button>
  </dt>

  <div class="d-flex justify-content-center align-items-center p-5" *ngIf="working.isWorking">
    <mat-spinner [diameter]="15" class="button-spinner dark"></mat-spinner>
  </div>

  <ng-container *ngIf="!working.isWorking">
    <dd *ngIf="notificationService.messageCount < 1">
      No hay notificaciones disponibles
    </dd>
    <div *ngFor="let item of notificationService.list" class="list-padding" [ngClass]="{'unread': !item.Seen}">
      <div class="inbox-content">
        {{item.Created | date:'medium' }}

        <p>{{item.Msg | mlc:multiLanguageService.retrigger}}</p>

        <button mat-flat-button class="mt-2" color="primary" (click)="updateSeen(item)">
          {{ 'inbox.view' | translate }}
        </button>

        <button mat-stroked-button class="mt-2 ml-1" color="secondary" (click)="tryDelete(item)">
          {{ 'inbox.delete' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</dl>

<!-- Notification Overlay -->
<div id="notifications-overlay" [ngClass]="{'show': notificationService.showNotifications == true}"
  (click)="toggleNotifications()">
</div>
